ready = ->
  $("body").on "click", ".close-titre-on-arrival-btn", (e) ->
    e.preventDefault()
    $(this).closest("#titre_on_arrival_wrapper").empty()

$(document).on 'turbolinks:load', ready